import { ToolkitStudyV1Request } from '@aloft/toolkit-shared';

import { Th } from '../../../components/pdf-export/Th/Th.js';
import { Tr } from '../../../components/pdf-export/Tr/Tr.js';
import { getAnalysisFeatureUnitString } from '../utils/getAnalysisFeatureUnitString.js';
import { sharedTableStyles } from './sharedTableStyles.js';

type Props = {
  term: ToolkitStudyV1Request['analysisFeature'];
};

export function StudyTableHeader({ term }: Props) {
  return (
    <Tr>
      <Th style={sharedTableStyles.address}>Address</Th>
      <Th style={sharedTableStyles.gla}>GLA</Th>
      <Th style={sharedTableStyles.site}>Lot (sf)</Th>
      <Th style={sharedTableStyles.saleDate}>Sale Date</Th>
      <Th style={sharedTableStyles.salePrice}>Adj SP</Th>
      <Th style={sharedTableStyles.term}>{getAnalysisFeatureUnitString(term)}</Th>
      <Th style={sharedTableStyles.difference}>Adj SP Difference</Th>
    </Tr>
  );
}
